import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion ,AnimatePresence} from "framer-motion";

function Moubant() {
const [index, setIndex] = useState(0);
 const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [formType, setFormType] = useState(""); // stores which button opened the form
 const [showModal, setShowModal] = useState(false);
   const [animate, setAnimate] = useState(false);
   const [loading, setLoading] = useState(false);
 const slides = [
    { text: "Delivering BANT-Qualified Leads That Drive Real Revenue" },
    { text: "Smarter Qualification. Stronger Pipelines. Better Results" },
    { text: "From Qualification to Conversion — Powered by BANT" },
  ];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.5, // delay between each div
    },
  },
};

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message } = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
        try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
 closeModal();
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
// alternate slide: left for odd, right for even
const itemVariants = (direction = "left") => ({
  hidden: { opacity: 0, x: direction === "left" ? -50 : 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.8, // slow fade + slide
      ease: "easeInOut",
    },
  },
});
   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };

  return (
    
    <div>
      <Header />
       <main>
      <AnimatePresence>
               {showSuccessModal && (
                 <motion.div
                   className="modal-overlay show"
                   initial={{ opacity: 0 }}
                   animate={{ opacity: 1 }}
                   exit={{ opacity: 0 }}
                   style={{
                     position: "fixed",
                     top: 0,
                     left: 0,
                     width: "100%",
                     height: "100%",
                     background: "rgba(0,0,0,0.5)",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     zIndex: 9999,
                   }}
                 >
                   <motion.div
                     className="modal show"
                     initial={{ scale: 0.8, opacity: 0 }}
                     animate={{ scale: 1, opacity: 1 }}
                     exit={{ scale: 0.8, opacity: 0 }}
                     transition={{ duration: 0.3 }}
                     style={{
                       background: "#fff",
                       padding: "30px",
                       borderRadius: "10px",
                       width: "400px",
                       textAlign: "center",
                       boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                     }}
                   >
                     <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                       Message Sent!
                     </h2>
                     <p>Thank you for contacting us. We will get back to you shortly.</p>
                     <button className="vc rg lk gh ml il hi gi _l"
                       onClick={() => setShowSuccessModal(false)}
                      
                     >
                       Close
                     </button>
                   </motion.div>
                 </motion.div>
               )}
             </AnimatePresence>
               {/* 🔹 Modal */}
                     {showModal && (
                       <div
                         className={`modal-overlay ${animate ? "show" : ""}`}
                         onClick={(e) => {
                           if (e.target.classList.contains("modal-overlay")) {
                             closeModal();
                           }
                         }}
                         style={{
                           position: "fixed",
                           top: 0,
                           left: 0,
                           right: 0,
                           bottom: 0,
                           background: "rgba(0, 0, 0, 0.5)",
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                           zIndex: 1000,
                           opacity: animate ? 1 : 0,
                           transition: "opacity 0.3s ease",
                         }}
                       >
                         <motion.div
                           className="modal-box"
                           initial={{ scale: 0.8, opacity: 0 }}
                           animate={{ scale: 1, opacity: 1 }}
                           exit={{ scale: 0.8, opacity: 0 }}
                           transition={{ duration: 0.3 }}
                           style={{
                             position: "relative",
                             background: "#fff",
                             padding: "30px",
                             borderRadius: "10px",
                             textAlign: "center",
                             boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                           }}
                         >
                           {/* Close button */}
                           <button
                             onClick={closeModal}
                             style={{
                               position: "absolute",
                               top: "10px",
                               right: "15px",
                               background: "transparent",
                               border: "none",
                               fontSize: "22px",
                               cursor: "pointer",
                               color: "#333",
                             }}
                           >
                             ×
                           </button>
             
                           <h2 className="fk tj kk wm bb">
                            Contact Now
                           </h2>
                        <form onSubmit={(e) => handleContactSubmit(e)}>
       <div className="tc sf yo ap zf xi1">
         <div className="vd to/2">
           <input
             type="text"
             name="fullname"
             id="fullname"
             placeholder="Full name"
             value={contactForm.fullname}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
     
         <div className="vd to/2">
           <input
             type="text"
             name="company"
             id="company"
              placeholder="Company name"
             value={contactForm.company}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
       </div>
     
       <div className="tc sf yo ap zf xi1">
         <div className="vd to/2">
           <input
             type="text"
             name="website"
             id="website"
               placeholder="Website"
             value={contactForm.website}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
     
         <div className="vd to/2">
           <input
             type="email"
             name="email"
              placeholder="Email address"
             id="email"
             value={contactForm.email}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
       </div>
     
       <div className="tc sf yo ap zf xi1">
         <div className="vd to/2">
          <input
       type="text"
       name="phone"
       id="phone"
         placeholder="Phone number"
       value={contactForm.phone}
       onChange={(e) => {
         // Allow only digits
         const value = e.target.value.replace(/\D/g, "");
         setContactForm((prev) => ({ ...prev, phone: value }));
       }}
       maxLength={10} // optional: limit to 10 digits
       className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
     />
     
         </div>
       </div>
     
       <div className="fb">
         <textarea
           placeholder="Message"
           rows="3"
           name="message"
           id="message"
           value={contactForm.message}
           onChange={handleContactChange}
           className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
         ></textarea>
       </div>
     
       <div className="tc xf">
           <button
       type="submit"
       className="vc rg lk gh ml il hi gi _l"
       disabled={loading}
     >
       {loading ? "Please wait..." : " Send Message"}
     </button>
     
       </div>
     </form>
                         </motion.div>
                       </div>
                     )}

 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/BANTVideo.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>
     <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
         <motion.section
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
            transition={{
              duration: 1.8,
              ease: "easeOut",
              type: "spring",
              stiffness: 40,
              damping: 20,
            }}
          ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
        BANT (Budget, Authority, Need, Time)
        </h2></motion.section>
     
      </div>
      <br/>
      <div className="container">
          <motion.section
             initial={{ opacity: 0, y: 100 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
             transition={{
               duration: 1.8,
               ease: "easeOut",
               type: "spring",
               stiffness: 40,
               damping: 20,
             }}
           >
        <div className="left">
          <img src="/images/bantimg.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
            <motion.section
               initial={{ opacity: 0, y: 100 }}
               whileInView={{ opacity: 1, y: 0 }}
               viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
               transition={{
                 duration: 1.8,
                 ease: "easeOut",
                 type: "spring",
                 stiffness: 40,
                 damping: 20,
               }}
             >
           <h3 className="fk tj kk wm bb _b mk">BANT: Turning Conversations Into Conversions</h3>
          <p className="uo">
            Mid- to late-funnel leads are vetted using proven qualification criteria that reliably indicate purchase readiness. Through BANT (Budget, Authority, Need, and Timeline), we deliver high-intent leads—each one confirmed to have the financial capacity, decision-making authority, clear need, and urgency to move forward.
      
          <ul className="hdse pdt1">
            <li>•	Sales-ready leads, pre-qualified through live conversations or targeted surveys, giving you clear insight into deal potential and timing. </li>
            <li>•	Prioritize outreach with confidence—each lead is already aligned with your value proposition, helping shorten the sales cycle and accelerate conversions.</li>
          </ul>
           </p>
         </motion.section>
        </div>
      </div>

    </section>

    
             <section className="i pg qh rm qi relative">
             <div className="animate_top bb ze rj ki xn vq">
               <motion.section
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                  transition={{
                    duration: 1.8,
                    ease: "easeOut",
                    type: "spring",
                    stiffness: 40,
                    damping: 20,
                  }}
                >
                      <h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
                     Our Process: Turning Interest Into Intent with BANT-Qualified Leads
                      </h2>
                      <p className="bb on/5 wo/3 jutfy">            We don’t just generate leads — we deliver sales-ready buyers who are actively exploring solutions like yours. Our process ensures every lead you receive is vetted for real purchase intent using proven qualification methods.
</p>
            </motion.section>
                    </div>
                 </section>
            
       <section className="i">
                 <div className="bb ze i va ki xn xq jb jo">
                     <motion.section
                          variants={containerVariants}
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: false, amount: 0.3 }}
                        >
                    <div className="wc qf pn pn gg cp">
                
                    <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
                       <div className="c i pg z-1">
                         <center>
                          <img src="images/filter.png" className="imgsizeicon" alt="Icon" /></center>
                       </div>
                       <h4 className="ek yj mk2 gb">Mid-to-Late Funnel Lead Identification</h4>
                      </motion.div>
           
            <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
                       <div className="c i pg z-1">
                         <center>
                          <img src="images/stamp.png" className="imgsizeicon" alt="Icon" /></center>
                       </div>
                       <h4 className="ek yj mk2 gb">BANT-Based Qualification Framework</h4>
                    </motion.div>
    
                       <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
                       <div className="c i pg z-1">
                         <center>
                          <img src="images/customer-service.png" className="imgsizeicon" alt="Icon" /></center>
                       </div>
                       <h4 className="ek yj mk2 gb">Human & Tech-Assisted Vetting</h4>
                     </motion.div>
    
                       <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
                       <div className="c i pg z-1">
                         <center>
                          <img src="images/leadership.png" className="imgsizeicon" alt="Icon" /></center>
                       </div>
                       <h4 className="ek yj mk2 gb">Delivery of Sales-Ready Leads</h4>
                      </motion.div>
                     
                   </div>  
                    <center>
                      <br/>
                      <motion.div variants={itemVariants("left")}>
                        <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Bant Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
  Talk to Our Expert 
</button></motion.div></center>
                    
                   </motion.section>
               <br/>
                 </div>
               </section>
    
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Moubant;
